import { render, staticRenderFns } from "./EmbeddedProvider.vue?vue&type=template&id=690378c4&scoped=true&"
import script from "./EmbeddedProvider.vue?vue&type=script&lang=js&"
export * from "./EmbeddedProvider.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedProvider.vue?vue&type=style&index=0&id=690378c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690378c4",
  null
  
)

export default component.exports